module.exports = __webpack_public_path__ + "media/images/country_flags/eu-35b2d983954aeb889b637ec205ac0bb0.png";